<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import addzt from '../../../common/ywlxgz/addzt/index.vue';
import ywgz from '../../../common/ywlxgz/ywgz/index.vue';
import mxdj from '@/components/page/DataGovernance/yhs/mxdj/index.vue';
import { addgs_quey, ywlxgz_query, ywlxgz_sczt } from '@/api/ywlxgz';
import { comMapping } from '@/components/util/Function/comMapping';

export default {
    name: 'ywlxgz',
    components: {
        mxdj,
        addzt,//新增账套
        ywgz// 业务规则
    },
    data: function() {
        return {
            tablekey: 0,
            overlength: 0,
            searchdata: getdata().searchdata,
            searchlist: getdata().searchlist,
            filterSearchlist: [],
            outlist: [],
            headData: getdata().headData,
            pagination: getdata().pagination,
            tableData: [],
            searchdiag: false,
            ztdiag: false,
            ywgzpg: false,
            formdata: {},
            ywzl: comMapping.$ywzx,
            sfmr: comMapping.$flag,
            ztid: 0,
            ywgzData: {},
            ywzx: "0",
            childrenTitle: "",
            wikiType: "0",
            pageType: "0"
        };
    },
    mounted() {
    },
    created() {
        this.init();
    },
    methods: {
        geOoverLength(e) {
            this.overlength = e;
        },
        businessRule(e) {
            // 业务规则点击事件
            this.ztid = e.id;
            this.ywgzData = e;
            this.ywzx = e.bsType
            this.ywgzpg = true;
        },
        basicInfo(e) {
            // 基本信息点击事件
            this.formdata = e;
            this.childrenTitle = "编辑账套基本信息";
            this.wikiType = "1";
            this.ztdiag = true;
        },
        copySetOfBook(e) {
            // 复制账套点击事件
            this.formdata = e;
            this.childrenTitle = "复制账套基本信息";
            this.wikiType = "2";
            this.ztdiag = true;
        },
        createSetOfBook() {
            // 新建账套点击事件
            this.formdata = {};
            this.childrenTitle = "新建账套基本信息";
            this.wikiType = "0";
            this.ztdiag = true;
        },
        setOfBookDelete() {
            // 删除点击事件
            let checkRow = this.$refs.tablebox.getSelectionval();
            if (checkRow && checkRow.length > 0) {
                this.$showConfirm({
                    message: '删除账套会取消该账套下所有对应的公司应用，确认删除该账套吗?'
                }).then(res => {
                    if (res === 'confirm') {
                        let checkIds = checkRow.map(item => item.id);
                        ywlxgz_sczt(checkIds).then(res => {
                            if (res.data.code !== '1') {
                                this.$message.error(res.data.msg);
                            } else {
                                this.$message.success(res.data.msg);
                                this.setOfBookQuery();
                            }
                        })
                    }
                })
            } else {
                this.$message.error("请选择需要删除的数据");
            }
        },
        //初始化
        init() {
            this.setOfBookQuery();
        },
        //查询
        setOfBookQuery() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.sort = '';
            params.order = '';
            ywlxgz_query(params).then(res => {
                if (res.data.code !== "1") {
                    this.$message.error(res.data.msg);
                } else {
                    this.pagination.total = res.data.data.total;
                    let data = res.data.data.records;
                    if (data && data.length > 0) {
                        // 已分配的code
                        let params = JSON.parse(JSON.stringify(this.searchdata));
                        addgs_quey(params).then(gsres => {
                            let xxcodes = data.filter(item => item.companyCode && item.companyCode !== "" && item.bsType === "1").map(item => item.companyCode).join(",");
                            let jxcodes = data.filter(item => item.companyCode && item.companyCode !== "" && item.bsType === "2").map(item => item.companyCode).join(",");
                            if (gsres.data.code !== 1) {
                                this.$message.error(res.data.msg);
                            } else {
                                if (gsres.data.data.records && gsres.data.data.records.length >0) {
                                    let jxGsData = gsres.data.data.records.filter(item => jxcodes.indexOf(String(item.companyCode)) === -1).map(item => item.nsrmc).join(",");
                                    let xxGsData = gsres.data.data.records.filter(item => xxcodes.indexOf(String(item.companyCode)) === -1).map(item => item.nsrmc).join(",");
                                    data.forEach(item => {
                                        if (!item.companyCode && item.defaulted === "1") {
                                            if (item.bsType === "1") {
                                                item.nsrmc = xxGsData;
                                            } else if (item.bsType === "2") {
                                                item.nsrmc = jxGsData;
                                            }
                                        }
                                    })
                                }
                            }
                        })
                    }
                    this.tableData = res.data.data.records;
                }
            });

        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.setOfBookQuery();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.setOfBookQuery();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.setOfBookQuery();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.filterSearchlist = e;
            this.searchlist = e.filter(item => item.isshow);
            this.searchdiag = false;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
            this.outlist = e.nochooselist;
        },
        forback() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.setOfBookQuery();
            this.ywgzpg = false;
        },
        closediag() {
            this.ztdiag = false;
            this.setOfBookQuery();
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
